import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { NzModalService } from 'ng-zorro-antd/modal';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  constructor(
    private swUpdate: SwUpdate,
    private modal: NzModalService,
    private translate: TranslateService,
  ) {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
        .subscribe(() => {
          this.promptUser();
        });
    }
  }

  private promptUser(): void {
    this.modal.confirm({
      nzTitle: this.translate.instant('PWA.TITLE'),
      nzContent: this.translate.instant('PWA.CONTENT'),
      nzOnOk: () => {
        document.location.reload();
      },
      nzOkText: this.translate.instant('PWA.UPDATE'),
      nzCancelText: this.translate.instant('PWA.CANCEL'),
    });
  }
}
